import React from 'react';
import { categoryConfig } from './taskConstants';

const sectionStyle = {
  backgroundColor: "var(--card-bg)",
  borderRadius: '6px',
  border: '1px solid var(--border)',
  padding: '12px',
  marginBottom: '12px'
};

const sectionHeaderStyle = {
  fontSize: '11px',
  fontWeight: 600,
  color: 'var(--text-muted)',
  marginBottom: '10px',
  textTransform: 'uppercase',
  letterSpacing: '0.5px'
};

function sidebarButtonStyle(active) {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '6px 12px',
    backgroundColor: active ? 'var(--primary-light)' : 'transparent',
    color: active ? 'var(--primary)' : 'var(--text-secondary)',
    cursor: 'pointer',
    textAlign: 'left',
    fontSize: '12px',
    fontWeight: active ? 600 : 400
  };
}

export default function TaskSidebar({
  selectedCategory,
  setSelectedCategory,
  groups,
  selectedGroup,
  setSelectedGroup,
  selectedStatus,
  setSelectedStatus
}) {
  return (
    <div style={{ width: '220px', flexShrink: 0 }}>
      {/* Categories */}
      <div style={sectionStyle}>
        <h3 style={sectionHeaderStyle}>Kategorie czasowe</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
          {Object.entries(categoryConfig).map(([key, cfg]) => (
            <button
              key={key}
              onClick={() => setSelectedCategory(key)}
              style={sidebarButtonStyle(selectedCategory === key)}
            >
              <span>{cfg.icon}</span>
              <span>{cfg.label}</span>
            </button>
          ))}
          <button
            onClick={() => setSelectedCategory('wszystkie')}
            style={sidebarButtonStyle(selectedCategory === 'wszystkie')}
          >
            <span>{'📑'}</span>
            <span>Wszystkie</span>
          </button>
        </div>
      </div>

      {/* Groups */}
      <div style={sectionStyle}>
        <h3 style={sectionHeaderStyle}>Grupy</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
          <button
            onClick={() => setSelectedGroup(null)}
            style={sidebarButtonStyle(!selectedGroup)}
          >
            <span>{'📁'}</span>
            <span>Wszystkie grupy</span>
          </button>
          {groups.map(group => (
            <button
              key={group.id}
              onClick={() => setSelectedGroup(group.id)}
              style={{
                ...sidebarButtonStyle(selectedGroup === group.id),
                justifyContent: 'space-between'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{
                  width: '8px',
                  height: '8px',
                  borderRadius: '50%',
                  backgroundColor: group.kolor
                }} />
                <span>{group.nazwa}</span>
              </div>
              <span style={{ fontSize: '10px', color: 'var(--text-muted)' }}>{group.task_count}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Status filter */}
      <div style={{ ...sectionStyle, marginBottom: 0 }}>
        <h3 style={sectionHeaderStyle}>Status</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
          {[
            { key: 'aktywne', label: 'Aktywne', icon: '⚪' },
            { key: 'w_trakcie', label: 'W trakcie', icon: '🔵' },
            { key: 'zakonczone', label: 'Zakończone', icon: '✅' },
            { key: null, label: 'Wszystkie', icon: '📑' }
          ].map(({ key, label, icon }) => (
            <button
              key={key || 'all'}
              onClick={() => setSelectedStatus(key)}
              style={sidebarButtonStyle(selectedStatus === key)}
            >
              <span>{icon}</span>
              <span>{label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
